/**
 * Statistical symbols that survive uppercase labels and fonts without
 * combining marks or subscript digits.
 */

/** σ₀, the standard error of unit weight. */
export const SigmaZero = () => (
  <span className="whitespace-nowrap normal-case tracking-normal">
    σ<sub>0</sub>
  </span>
);

/** τ, kept lowercase so it never reads as a Latin “T” in uppercase labels. */
export const Tau = () => <span className="normal-case tracking-normal">τ</span>;

/** A lowercase symbol inside an uppercase label, e.g. redundancy “r”. */
export const MathSymbol = ({ children }: { children: string }) => (
  <span className="normal-case tracking-normal">{children}</span>
);
